import { PersistMessage } from 'src/state/scope/Scope.types';
import {
  PublishEventPayload,
  WorkingSetContextPayload,
  WorkingSetReport,
} from 'src/state/workingSets/workingSets.slice';

export type EventSourceContext = 'mfp' | 'assortment';

//#region assortment

export interface ServerSentEventType {
  type: AssortmentEventType | MfpEventType;
  /** Determines whether this event should log if not present in the events stream when the sse connects */
  required: boolean;
}

export enum AssortmentEventType {
  planQueue = 'plan_queue',
  allocPlanQueue = 'alloc_plan_queue',
  worklist = 'worklist',
  fingerprint = 'fingerprint',
  add_to_assortment = 'add_to_assortment',
  ping = 'ping',
  agent_conversations = 'agent_conversations',
  agent_message = 'agent_message',
}

export const assortmentEventTypes: ServerSentEventType[] = Object.values(AssortmentEventType).map((et) => ({
  type: et,
  required: ['agent_conversations', 'agent_message'].includes(et) ? false : true,
}));

interface BaseAsstServerEvent extends Event {
  data: string;
}

export interface AssortmentServerEvent extends BaseAsstServerEvent {
  type:
    | typeof AssortmentEventType.planQueue
    | typeof AssortmentEventType.allocPlanQueue
    | typeof AssortmentEventType.worklist
    | typeof AssortmentEventType.fingerprint
    | typeof AssortmentEventType.ping
    | typeof AssortmentEventType.add_to_assortment
    | typeof AssortmentEventType.agent_conversations
    | typeof AssortmentEventType.agent_message;
}

//#endregion

//#region mfp

export enum MfpEventType {
  context = 'context-async-state',
  persist = 'context-persist-state',
  report = 'report-async-state',
  publish = 'publish-event-status',
  actuals = 'actuals-event-status',
  heartbeat = 'ping',
}

// filtering out actuals because that event type was not previously registered at all
export const mfpEventTypes: ServerSentEventType[] = Object.values(MfpEventType)
  .filter((t) => t !== MfpEventType.actuals)
  .map((et) => ({ type: et, required: et !== MfpEventType.publish }));

interface ContextsEvent extends Event {
  type: MfpEventType.context;
  data: WorkingSetContextPayload[];
}
interface PersistEvent extends Event {
  type: MfpEventType.persist;
  data: PersistMessage;
}
interface ReportEvent extends Event {
  type: MfpEventType.report;
  data: WorkingSetReport[];
}

export interface PublishEvent extends Event {
  type: MfpEventType.publish;
  data: PublishEventPayload;
}

interface ActualsEvent extends Event {
  type: MfpEventType.actuals;
  data: never;
}

interface HeartbeatEvent extends Event {
  type: MfpEventType.heartbeat;
  data: string | number;
}

export type MfpServerEvent = ContextsEvent | PersistEvent | ReportEvent | PublishEvent | ActualsEvent | HeartbeatEvent;

//#endregion
